import { CatalogListWithItemsModel } from "api";
import { calcNextState } from "helpers/dictionaries";
import { defaultConstants, handleActions } from "helpers/redux";
import { Action } from "redux-actions";

const { GET_ITEMS, SET_LOADING, MERGE_PARAMS } = defaultConstants("DICTIONARIES");

const initialState = {
    items: [],
    enums: {},
    formConfigs: [],
    brands: {},
    params: {
        start: 0,
    },
    count: 0,
    isInitialLoading: true,
    isLoadingList: true,
    isLoadingCount: true,
    shouldUpdate: false,
};

type State = {
    items: CatalogListWithItemsModel[];
    enums: {};
    formConfigs: {}[];
    brands: {};
    params: {
        start?: number;
        length?: number;
        filters?: [];
        queryFilter?: {};
    };
    isInitialLoading: boolean;
    count: number;
    isLoadingList: boolean | {};
    isLoadingCount: boolean | {};
    shouldUpdate: boolean;
};
type GetItemsPayload = { count: number; data: CatalogListWithItemsModel[] };
type MergeParamsPayload = {};

type CombinedPayloads = GetItemsPayload | MergeParamsPayload;

export default handleActions<State, CombinedPayloads>(
    {
        [GET_ITEMS]: (state, { payload }: Action<GetItemsPayload>) =>
            ({
                ...state,
                ...calcNextState(payload.data),
                isInitialLoading: false,
                isLoadingList: false,
                isLoadingCount: false,
                count: payload.count,
                shouldUpdate: false,
            }) as State,
        [SET_LOADING]: (state) => ({
            ...state,
            isLoadingList: true,
            isLoadingCount: true,
            shouldUpdate: false,
        }),
        [MERGE_PARAMS]: (state, { payload }: Action<MergeParamsPayload>) => ({
            ...state,
            params: { ...state.params, ...payload },
            shouldUpdate: true,
        }),
    },
    initialState,
);
